var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3029 41.1941L0.702914 25.5941C-0.234305 24.6569 -0.234305 23.1373 0.702914 22.2L4.09695 18.8059C5.03416 17.8686 6.55385 17.8686 7.49107 18.8059L18 29.3147L40.5089 6.80588C41.4461 5.86866 42.9658 5.86866 43.903 6.80588L47.297 10.2C48.2343 11.1372 48.2343 12.6568 47.297 13.5941L19.697 41.1942C18.7597 42.1314 17.2401 42.1314 16.3029 41.1941V41.1941Z"
  })));
};
export default SvgCheck;